import React, { useEffect, useState } from "react";
import { debug } from "../../utils";
import { connect } from "react-redux";
import * as validationService from "../add-device-modal/validationService";

function PowerCLIPaswordField({ value, anotherSectionActive, onChange, passwordChanged, onChangePasswordClick, centralCredentialId, error, disabled }) {

    const [disableInput, setDisableInput] = useState(true)
    const [showChangeBtn, setShowChangeBtn] = useState(true)  

    const ProcessData = async () => {
        if (anotherSectionActive) {
            validationService.cleanValidation('powerCliPassword');
            setDisableInput(true);
            //onChange('');
        } 
        else if (centralCredentialId && centralCredentialId > 0) {
            validationService.cleanValidation('powerCliPassword');            
            setShowChangeBtn(false);
            setDisableInput(true);
            onChange('');
        } 
        else {
            validationService.validateNotEmpty(value, 'powerCliPassword');
            if (passwordChanged && showChangeBtn && disableInput) {
                setShowChangeBtn(true);
                setDisableInput(false);
            } 
            else if (passwordChanged && showChangeBtn && !disableInput) {
                setShowChangeBtn(false);
                setDisableInput(false);
            } 
            else if (passwordChanged && !showChangeBtn && disableInput) {
                setShowChangeBtn(false);
                setDisableInput(false);
            }
            else if (passwordChanged && !showChangeBtn && !disableInput) {
                setShowChangeBtn(false);
                setDisableInput(false);
            }  
            

            else if (!passwordChanged && !showChangeBtn && !disableInput) {
                setShowChangeBtn(false);
                setDisableInput(false);
            } 
            else if (!passwordChanged && !showChangeBtn && disableInput) {
                setShowChangeBtn(false);
                setDisableInput(false);
            }
            else if (!passwordChanged && showChangeBtn && disableInput) {
                setShowChangeBtn(true);
                setDisableInput(true);
            } 
             
            else {
                setDisableInput(true); 
            }         
        }
        return () => validationService.cleanValidation('powerCliPassword');
    }
    useEffect(() => {
        ProcessData();
        /* eslint-disable react-hooks/exhaustive-deps */
      
    }, [value, anotherSectionActive, centralCredentialId])
    
    // useEffect(() => {
    //     if (anotherSectionActive) {
    //         validationService.cleanValidation('powerCliPassword');
    //     } else {
    //         validationService.validateNotEmpty(value, 'powerCliPassword');
    //     }
    //     return () => validationService.cleanValidation('powerCliPassword');
    // }, [value, anotherSectionActive])

    return (
        <div className="form-group">
            <div className="oct_form-group">
                <label htmlFor="powercli_password">Password <span className="modal-v2-required-mark">*</span></label>
                <div className="modal-v2-field-action-row">
                    <input className={`form-control oct_field ${error && 'border-danger'}`}
                        id="powercli_passowrd-key"
                        type="password"
                        disabled={disableInput}
                        value={centralCredentialId ? '' : value}
                        onChange={disableInput ? null : event => onChange(event.target.value)} />
                    {showChangeBtn
                        && value
                        && <button type="button"
                            className="modal-v2-btn modal-v2-btn-primary modal-v2-inline-change-btn"
                            onClick={!disableInput ? null : () => onChangePasswordClick()}>
                            Change
                        </button>}
                </div>
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    debug("PowerCLIPaswordField mapStateToProps", state);
    const validation = state.validation;
    return {
        error: validation.powerCliPassword
    }
}

export default connect(mapStateToProps)(PowerCLIPaswordField);
